<script>
import Spinner from '~/components/Spinner.vue';

export default {
    name: "Index",
    components: { Spinner },
    mounted() {
        if (process.client) {
            let checkCart = localStorage.getItem('cart');
            if (checkCart && this.$route.name === 'index') {
                checkCart = JSON.parse(checkCart);
                if (typeof checkCart[0] !== 'undefined') {
                    this.$router.push('/' + checkCart[0].hash);
                } else {
                    this.$router.push('/cart-empty');
                }

            }
        }
    }
}
</script>
<template>
    <div>
        <Spinner />
    </div>
</template>

<style scoped>
@import url('@/assets/css/tailwind.css');

body {
    margin: 0px
}

html {
    font-family: 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI',
        Roboto, 'Helvetica Neue', Arial, sans-serif;
    font-size: 16px;
    word-spacing: 1px;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    box-sizing: border-box;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    box-sizing: border-box;
    --scroll-behavior: smooth;
    scroll-behavior: smooth;
}</style>
